import { useCalendarGridContext } from '../../CalendarGrid.hooks'
import { CalendarGridItemCardDefault } from '../CalendarGridItemCardDefault'

function CalendarGridItemCardContent({ item, onClickItem, onClose }) {
  const { ItemCard } = useCalendarGridContext()

  const Card = ItemCard ?? CalendarGridItemCardDefault

  return <Card item={item} onClickItem={onClickItem} onClose={onClose} />
}

export default CalendarGridItemCardContent
